import Vue from 'vue'
import { Promised } from 'vue-promised'
import BootstrapVue from 'bootstrap-vue'
import StarRating from "vue-star-rating"

import App from './App.vue'
import router from './router'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import './registerServiceWorker'

Vue.use(BootstrapVue)
Vue.component('Promised', Promised)
Vue.component('v-select', VueSelect.VueSelect)
Vue.component('StarRating', StarRating)


Vue.config.productionTip = false

new Vue({
	router,
	render: h => h(App)
}).$mount('#app')
